/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { Modal, Input, message as toaster } from 'antd';
import PropTypes from 'prop-types';
// import { useDispatch } from 'react-redux';
import * as Pusher from 'pusher-js';
import { isEmpty } from 'lodash';
import { Image, Text, Box, Flex, Button as AtomButton } from 'atoms';
import { theme } from 'styles/theme';
import { Rupee } from 'components';
// import { triggerFailUPI } from 'store/collectionSlice';
// import { getNotifications } from 'store/notificationSlice';
import { ClearConfirmation, QRTimerConfirmation } from 'components/pages/collection';
import { useAuth } from 'hooks';
import RipplrLogo from 'assets/ripplr-logo.svg';
import * as Styled from './UPIAutoComplete.style';
// import { triggerFailUPI } from 'store/collectionSalesmanSlice';

export const InputLabel = styled(Box)`
	position: absolute;
	top: -15px;
	left: 0px;
	z-index: 1;
	font-size: 8px;
	line-height: 10px;
	color: ${theme.colors.Jet};
`;

export const InputField = styled(Input)`
	width: 100%;
	height: 32px;
	padding: 0 26px 0 12px;
	border: 0;
	font-size: 10px;
	background-color: #f6f6f6;
`;

export const SubmitBtn = styled(AtomButton)`
	background-color: #0ba86e;
	text-align: center;
	padding: 0;
	border: 0;
	outline: none;
	width: 100%;
	height: 40px;
	line-height: 40px;
`;

let pusher = null;

// const cashierVerifiedStatus = (value) =>
// 	['VerifiedByCashier', 'PartialVerifiedByCashier']?.includes(value.invoice_verification_status);

export default function ManualUPiEdit({
	visible,
	handleCancel,
	totalOutstanding,
	upiData,
	storeData,
	dynamicUPIData,
	setDynamicUPIData,
	manualModeEditData,
	formRef,
	handleDeleteManualUPI,
	handleQRCodeSubmit,
	storeInvoices,
	storeInfo,
}) {
	const [upiAmount, setUPIAmount] = useState(''); // Entered Amount
	const [UPISearchVal, setUPISearchVal] = useState('');
	const [errorVal, setErrorVal] = useState('');
	// const [outStandingErrorVal, setOutStandingErrorVal] = useState(false);
	const [mode, setMode] = useState(null); // Manual || qrcode
	const [QRCodeImg, setQRCodeImg] = useState(null);
	// const [showUpiPopup, setShowUpiPopup] = useState(false);
	const [deleteConfirmation, setDeleteConfirmation] = useState(false);
	const [qrTimerClose, setQrTimerClose] = useState(false);
	// const dispatch = useDispatch();
	const intervalRef = useRef(null);
	const { id } = useAuth();
	const pusherData = useRef();

	const UPI_REF_LENGTH = 8;
	const onlyNumbers = /^[0-9\b]+$/;

	console.log(storeInvoices, 'storeDatastoreData');

	const clearTimer = () => {
		clearInterval(intervalRef.current);
		intervalRef.current = null;
	};

	const handleManualModeClick = useCallback(() => {
		// setShowUpiPopup(true);
		setMode('Manual');
		clearTimer();
		setQRCodeImg(null); // on manual mode switch clear the qr code
	}, []);

	// const cashierVerified = useMemo(
	// 	() => storeInvoices?.some(cashierVerifiedStatus),
	// 	[storeInvoices]
	// );

	useEffect(() => {
		console.log(upiAmount);

		/**
		 * On component load clear already added data
		 */
		if (visible) {
			setUPIAmount('');
			setMode(null);
			setQRCodeImg(null);
			// setShowUpiPopup(false);
			setUPISearchVal('');
			setErrorVal('');
			if (manualModeEditData?.data?.reference_number) {
				setUPISearchVal(manualModeEditData?.data?.reference_number);
				// setReferenceNo(manualModeEditData?.data?.reference_number);
			}
		} else {
			// setShowUpiPopup(false);
		}

		return () => clearTimer();
	}, [visible]);

	useEffect(() => {
		if (upiAmount) {
			console.log(upiAmount);
		}
		console.log({
			dynamicUPIData,
			manualModeEditData,
		});
	}, [upiAmount]);

	function handleFailUPI() {
		// If popup closed with in 100 seconds send the reason as `PopUpClosed`

		if (upiAmount) {
			// dispatch(getNotifications(id));
			// dispatch(
			// 	triggerFailUPI({
			// 		store_id: storeData?.store_id,
			// 		user_id: storeData?.salesman_id,
			// 		amount: upiAmount,
			// 	})
			// );
		}
	}

	useEffect(() => {
		if (manualModeEditData?.isManualEditMode) {
			handleManualModeClick();
			setUPIAmount(manualModeEditData?.data?.amount?.toString());
			// setUPIRef(manualModeEditData?.data?.reference_number?.toString());
		}
	}, [handleManualModeClick, manualModeEditData]);

	useEffect(() => {
		if (UPISearchVal || upiAmount) {
			setDynamicUPIData({
				reference_number: UPISearchVal,
				bank_statement_id: '',
				upiAmount,
				type: 'Manual',
			});
		}
		console.log(upiAmount);
	}, [UPISearchVal, upiAmount]);

	const showSuccessMessage = (data = {}) => {
		console.log('data', data);
		const { batchAmtCcd = 'INR', batchAmt = 0, utrNo, productCode } = data || {};

		console.log(data, 'Push notification');

		toaster.success(`${batchAmtCcd} ${batchAmt} Received. Reference Number is ${utrNo}`);

		const saveData = {
			reference_number: utrNo,
			bank_statement_id: null,
			upiAmount: Number(batchAmt),
			type: productCode === 'UPICOLL' ? 'qrcode' : 'Manual',
		};

		handleQRCodeSubmit(saveData);
		clearTimer();
	};

	useEffect(() => {
		console.log('useEffect pusherData', pusherData);
		if (id && !pusherData.current && visible) {
			pusher = new Pusher(process.env.REACT_APP_PUSHER_CODE, {
				cluster: 'ap2',
				forceTLS: true,
			});

			console.log('channel id', `salesman_${id}`);

			const channel = pusher.subscribe(`salesman_${id}`);

			console.log('channel', channel);

			/** *
			 * add pusher details to ref, this will create channel one time only
			 */
			pusherData.current = pusher;

			console.log('pusherData.current', pusherData.current);

			/**
			 * Channels
			 */
			/**
			 * Events
			 */
			channel.bind('upi_payment', (data) => {
				console.log('upi_payment', data);
				showSuccessMessage(data?.message?.body);
			});
		} else {
			console.log('pusher already added Dynamic QR', pusherData, pusher);
		}

		return () => {
			console.log('came to last return');
			console.log('pusher', !isEmpty(pusher));
			console.log('id', id);
			console.log('visible', visible);
			console.log('all logic data', !isEmpty(pusher) && id && !visible);

			if (!isEmpty(pusher) && id && visible) {
				console.log('came for unsubscribe');
				pusher.unsubscribe(`salesman_${id}`);
				pusherData.current = null;
			}
		};
	}, [id, visible]);

	const extraAllowedAmount = useMemo(
		() => {
			const extra = Number(totalOutstanding);

			return extra > 100000 ? 100000 : extra;
		}, // allow extra 600 from collectable amount
		[totalOutstanding]
	);

	const handleChange = (e) => {
		const { value } = e.target;

		console.log(extraAllowedAmount);
		console.log(value);

		setQRCodeImg(null); // on amount change clear the qr code
		setUPIAmount(Number(value));
		setMode(null);
		// if (manualModeEditData?.isManualEditMode) {
		// 	handleManualModeClick();
		// 	setUPIAmount(manualModeEditData?.data?.amount?.toString());
		// 	// setUPIRef(manualModeEditData?.data?.reference_number?.toString());
		// }
	};

	const refHandleChange = (e) => {
		const { value } = e.target;

		if (value.length >= UPI_REF_LENGTH) {
			setErrorVal('');
		}
		// else {
		// 	setErrorVal(`Enter atleast ${UPI_REF_LENGTH} reference number`);
		// }

		if (!onlyNumbers.test(value)) {
			setErrorVal('Number only allowed and enter more than 8 digits');
		} else {
			setUPISearchVal(value);
		}
	};

	function handleDeleteCurrentRecord() {
		setDeleteConfirmation(false);
		/**
		 * On delete confirmation delete current selected manual upi data
		 */
		console.log(formRef.current);
		console.log(upiData);
		console.log(manualModeEditData);

		formRef.current.setValues({
			...formRef.current.values,
			upiData: formRef.current.values.upiData.filter(
				(upi) => upi.id !== manualModeEditData?.data?.id
			),
		});
		console.log(formRef.current);
		setTimeout(() => {
			handleCancel();
			handleDeleteManualUPI();
		}, 100);
	}

	function handleClose() {
		handleFailUPI();
		setQrTimerClose(false);
		setTimeout(() => {
			handleCancel();
		}, 1500);
	}

	function handleQRPopupClose() {
		if (QRCodeImg && upiAmount && mode === 'qrcode') {
			setQrTimerClose(true);
		} else {
			handleClose();
		}
	}

	const amount_state = ['EDITAMOUNT', 'EDITAMOUNTORDATA', '', 'DEFAULT'];
	const getAmountState = (val) => {
		console.log(val);
		if (storeInfo?.store_info?.can_salesman_edit === false) {
			return true;
		}
		if (val?.block_edit_state === 1) {
			return true;
		}
		if (amount_state.includes(val?.state) || val?.state === undefined) {
			return false;
		}
		if (val?.state === 'PERSIST') {
			return true;
		}

		return true;
	};

	// const onlyamoun = ['EDITAMOUNT'];

	// const getOnlyAmounyState = (val) => !!onlyamoun.includes(val?.state);

	const data_state = ['EDITDATA', 'EDITAMOUNTORDATA', '', 'DEFAULT'];
	const getDataStateCheck = (val) => {
		if (storeInfo?.store_info?.can_salesman_edit === false) {
			return true;
		}
		if (val?.block_edit_state === 1) {
			return true;
		}
		if (data_state.includes(val?.state) || val?.state === undefined) {
			return false;
		}
		if (val?.state === 'PERSIST') {
			return true;
		}

		return true;
	};

	// useEffect(() => {
	// 	if()
	// }, [handleManualModeClick, manualModeEditData]);

	const verified = ['VerifiedByCashier'];
	const checkDisabledCondition = () => {
		console.log(manualModeEditData, 'UPISearchVallength');
		console.log(upiAmount);
		console.log(totalOutstanding);

		if (verified.includes(manualModeEditData?.data?.payment_verification_status)) {
			return true;
		}

		if (manualModeEditData?.data?.block_edit_state === 0) {
			return false;
		}
		if (upiAmount > totalOutstanding + 600) {
			if (manualModeEditData?.data?.block_edit_state === 0) {
				return false;
			}
			if (manualModeEditData?.data?.block_edit_state) {
				return true;
			}

			return true;
		}

		if (UPISearchVal.length >= 8 && upiAmount > 0) {
			return false;
		}
		// if (upiAmount > totalOutstanding) {
		// 	setOutStandingErrorVal(true);

		// 	return true;
		// }
		// if (totalOutstanding >= upiAmount) {
		// 	setOutStandingErrorVal(false);

		// 	return false;
		// }

		return false;
	};

	const UpdateNewValues = () => {
		handleQRCodeSubmit({
			...dynamicUPIData,
			manualModeEditData,
		});
	};

	const disbaledBtn = (val, data) => {
		console.log(val, 'disbaledBtn');
		console.log(data, 'disbaledBtndata');

		if (amount_state.includes(data?.data?.state)) {
			return false;
		}
		if (val?.payments_edit === false) {
			return true;
		}
		if (data?.block_edit_state) {
			return true;
		}
		if (storeInfo?.store_info?.can_salesman_edit === false) {
			return true;
		}

		return false;
	};

	console.log(totalOutstanding, 'totalOutstanding');
	console.log(manualModeEditData, 'manualModeEditData');

	return (
		<Modal
			title={
				<Box>
					<Image
						src={RipplrLogo}
						alt="Ripplr Logo"
						style={{
							width: 'auto',
							height: '20px',
						}}
					/>
				</Box>
			}
			visible={visible}
			onCancel={handleQRPopupClose}
			style={{
				width: '90%',
			}}
			maskClosable={false}
			footer={null}
		>
			<Text textAlign="center" fontSize="10px" color={theme.colors.DavysGrey}>
				Collectable Amount:
			</Text>
			<Text textAlign="center" fontSize="16px" fontWeight="600">
				<Rupee>{totalOutstanding}</Rupee>
			</Text>

			<Box marginBottom="1rem">
				<Styled.StoreName>{storeData?.store_name || 'NA'}</Styled.StoreName>
				<Styled.InvoiceNumber>{storeData?.invoice_number || ''}</Styled.InvoiceNumber>
			</Box>
			<br />
			<Flex my="1.25rem" alignItems="center">
				<Box width="70%">
					<InputLabel>Enter Amount</InputLabel>
					<InputField
						value={upiAmount}
						placeholder="₹"
						onChange={handleChange}
						type="number"
						min="1"
						disabled={getAmountState(manualModeEditData?.data)}
					/>
				</Box>
			</Flex>
			<br />
			<Flex my="1.25rem" alignItems="center">
				<Box width="70%">
					<InputLabel>Enter *UTR Ref no</InputLabel>
					<InputField
						value={UPISearchVal}
						placeholder="Enter reference number(minimum 12 characters)"
						onChange={refHandleChange}
						maxLength={20}
						minLength={8}
						disabled={getDataStateCheck(manualModeEditData?.data)}
					/>
					<Styled.InputErrorMsg as="p">{errorVal}</Styled.InputErrorMsg>
				</Box>
			</Flex>

			{!upiData && (
				<Text color="red" fontSize="10px" textAlign="center">
					* UPI QR Code Not Available, contact support team
				</Text>
			)}
			{/* {outStandingErrorVal && (
				<Text color="red" fontSize="10px" textAlign="center">
					* UPI amount is greter than Outstanding
				</Text>
			)} */}

			{upiAmount && manualModeEditData?.isManualEditMode && (
				<>
					<Flex alignItems="center" justifyContent="space-between">
						<AtomButton
							variant="danger"
							onClick={() => setDeleteConfirmation(true)}
							disabled={disbaledBtn(storeInfo?.store_info, manualModeEditData)}
						>
							Delete Record?
						</AtomButton>
					</Flex>
					{/* <UPIAutoCompleteManual
						showUpiPopup={showUpiPopup}
						storeData={storeData}
						setDynamicUPIData={setDynamicUPIData}
						upiAmount={upiAmount}
						cashierVerified={cashierVerified}
						manualModeEditData={manualModeEditData}
					/> */}
					{/* {dynamicUPIData?.reference_number && (
						<Flex justifyContent="center" alignItems="center" mt="1rem">
							<SubmitBtn
								onClick={() => {
									handleQRCodeSubmit({
										...dynamicUPIData,
										manualModeEditData,
									});
								}}
								disabled={!dynamicUPIData?.reference_number}
							>
								{manualModeEditData?.isManualEditMode ? 'Update' : 'Submit'}
							</SubmitBtn>
						</Flex>
					)} */}
				</>
			)}

			<Flex justifyContent="center" alignItems="center" mt="1rem">
				<SubmitBtn
					onClick={() => {
						UpdateNewValues();
					}}
					disabled={checkDisabledCondition()}
				>
					{manualModeEditData?.isManualEditMode ? 'Update' : 'Submit'}
				</SubmitBtn>
			</Flex>

			<ClearConfirmation
				visible={deleteConfirmation}
				onClose={() => setDeleteConfirmation(false)}
				onClear={handleDeleteCurrentRecord}
				infoText="Are you sure want to delete the record?"
				yesText="Yes"
			/>
			<QRTimerConfirmation
				visible={qrTimerClose}
				onClose={() => setQrTimerClose(false)}
				onClear={handleClose}
				infoText="The payment process is currently underway. Are you certain you want to close?"
				yesText="Yes"
			/>
		</Modal>
	);
}

ManualUPiEdit.propTypes = {
	visible: PropTypes.bool.isRequired,
	handleCancel: PropTypes.func.isRequired,
	totalOutstanding: PropTypes.number.isRequired,
	upiData: PropTypes.string,
	storeData: PropTypes.object,
	dynamicUPIData: PropTypes.object,
	manualModeEditData: PropTypes.object,
	formRef: PropTypes.object,
	setDynamicUPIData: PropTypes.func.isRequired,
	handleDeleteManualUPI: PropTypes.func.isRequired,
	handleQRCodeSubmit: PropTypes.func.isRequired,
	storeInvoices: PropTypes.any,
	storeInfo: PropTypes.any,
};
